<div class="small-chart-widget chart-widgets-small">
   <div class="card">
     <div class="card-header">
       <h5>{{ 'Live Products' | translate }}</h5>
     </div>
     <div class="card-body">
       <div class="chart-container">
         <div class="row">
           <div class="col-12">
             <div id="chart-widget6">
               <apx-chart [chart]="liveProducts.chart" [stroke]="liveProducts.stroke" [series]="liveProducts.series" [fill]="liveProducts.fill" [dataLabels]="liveProducts.dataLabels" [grid]="liveProducts.grid" [colors]="liveProducts.colors" [labels]="liveProducts.labels" [markers]="liveProducts.markers" [xaxis]="liveProducts.xaxis" [yaxis]="liveProducts.yaxis" [tooltip]="liveProducts.tooltip"></apx-chart>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>